import { Employer, Parent } from '@app-models';

// Check this class for items that are not truly required
export class ClaimEmployer {
    id?: number;
    employer: Employer | null;
    employerParent: Parent | null;
    employerEmployeeStartDate: string | null;
    employerUnemploymentStartDate: string | null;
    employerUnemploymentNotificationDate: string | null;
    employerEmploymentType: string | null;
    employerPartTimeHoursPerWeek: number | null;
    employerUnemploymentType: string | null;
    employerUnemploymentReason: string | null;
    employerCertifyingOfficialName: string | null;
    employerCertifyingOfficialTitle: string | null;
    employerCertifyingOfficialSignatureDate: string | null;
    employerSignature: string | null;
    employerCertifyingOfficialContact: string | null;
    employerParentRelocationDate: string | null;
    employerRelocationTransferDate: string | null;
}
